import * as React from "react";
import { Hidden, Divider, Stack } from "@origin-digital/ods-core";
import { useHistory, useParams } from "react-router-dom";
import { logger } from "@origin-digital/reporting-client";
import { findLabel, SearchLevel } from "../helpers/mapping";
import { IAppContext } from "../AppContext";
import { LoginViewMessagesController } from "../components/LoginViewMessages";
import { SubCategoryListController } from "../components/SubCategoryList";
import { routes } from "../helpers/router.helper";
import { UseParamsType } from "../router";
import { IMetaData } from "../../../shared/interface/article";
import { ScreenTemplate } from "./ScreenTemplate";

interface IProps {
  context: IAppContext;
}

export const SubCategory = ({ context }: IProps) => {
  const { navigation, isNative } = context;

  const { category, subCategory } = useParams() as UseParamsType;
  const history = useHistory();

  const categories = navigation.data ? navigation.data.categories : [];
  const data = findLabel(categories, subCategory, SearchLevel.SUBCATEGORY);

  if (!data && navigation.data) {
    logger.warn(`[SubCategory] cannot find subcategory: "${subCategory}"`, {
      navigationData: navigation.data,
    });
    history.replace(routes.category(category));
  }

  const title = data ? data.displayName : "";
  const description = data ? data.metaDesc : "";

  const metaData: IMetaData = {
    metaTitle: data?.metaTitle,
    metaDescription: data?.metaDesc,
  };

  return (
    <ScreenTemplate
      title={title}
      description={description}
      data-id="subcategory"
      isNative={isNative}
      metaData={metaData}
      labelId={data?.labelId}
    >
      <Stack space="xxlarge">
        <SubCategoryListController
          labelId={data?.labelId}
          categorySlug={category}
          subcategorySlug={subCategory}
          data-id="subcategory-page-article-list"
        />
        {!context.isNative && (
          <Hidden above="md">
            <Stack space={["large", "xlarge"]}>
              <Divider />
              <LoginViewMessagesController />
            </Stack>
          </Hidden>
        )}
      </Stack>
    </ScreenTemplate>
  );
};
